<div class="copyclipboard" [clipboard]="lemma" (clipboardCopy)="logSuccess($event, action)" (clipboardError)="logError($event, action)"
>

    <i class="material-icons">content_copy</i> {{ 'CONTEXTMENU.COPYTO' | translate }}
</div>
